<template>
  <div class="sticky bottom-2 mt-8">
    <div
      class="relative rounded-app bg-white p-2 shadow-[0_0_15px_-3px_rgba(0,0,0,0.1),0_0_6px_-4px_rgba(0,0,0,0.1)]"
    >
      <div class="flex flex-wrap gap-2">
        <div class="flex flex-1 md:mr-auto md:flex-none">
          <Button
            :content="__('Cancel')"
            type="submit"
            :disabled="isLoading"
            variation="outline"
            @click="redirectToPage('redesign.company.jobs.index', 'active')"
            value="Cancel"
            class="flex-1 sm:flex-none"
          >
          </Button>
        </div>
        <Button v-if="metadata.active_job_templates"
          :content="__('Create template from this job')"
          type="submit"
          :disabled="isLoading"
          variation="outline"
          @click="updateAction('createTemplateFromJob')"
          value="Save"
          :show-loading-spinner="false"
          :is-loading="isLoading"
          class="flex-1 sm:flex-none"
        />
        <Button
          :content="metadata.status ? __('Unlist') : __('Save')"
          type="submit"
          :disabled="isLoading"
          variation="outline"
          @click="updateAction('save')"
          value="Save"
          class="flex-1 sm:flex-none"
        />
        <Button
          :content="metadata.status ? __('Save') : __('Post job')"
          type="submit"
          :disabled="isLoading"
          variation="fill"
          @click="updateAction('post')"
          value="Post"
          class="flex-1 sm:flex-none"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
  import { reactive } from 'vue';

  import { Button } from '../../../../components/global';
  import { __, redirectToPage } from '../../../../helpers';

  const props = defineProps({
    isLoading: {
      type: Boolean,
      required: true
    },
    metadata: {
      type: Object,
      required: true
    }
  });

  const emit = defineEmits(['update:status', 'updateAction']);

  const updateAction = (val) => {
    emit('updateAction', val);
  };

  const setStatus = (val) => {
    emit('update:status', val);
  };
</script>
